module.exports = "<form name=\"asuiDynamicForm\">\n    <h3 ng-if=\"$ctrl.subject\">{{$ctrl.subject}}</h3>\n    <div ng-repeat=\"item in $ctrl.items\">\n        <asui-form-component item='item' form=\"asuiDynamicForm\" items='$ctrl.items'></asui-form-component>\n    </div>\n    <button type=\"submit\" class=\"asui-btn btn btn-primary\" ng-click=\"$ctrl.submit()\" ng-disabled=\"asuiDynamicForm.$invalid \">{{$ctrl.submitButtonText}}</button>\n</form>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/components/asui-form/asuiForm.component.html
// module id = 720
// module chunks = 0